module.exports = __webpack_public_path__ + "media/assets/images/met_red-3d8af5209659d4ea1ecd1476a1830de6.png";